import TextArea from 'antd/es/input/TextArea';

export default TextArea;
